import React from 'react';

interface CheckboxProps {
  checked?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
  required?: boolean;
  disabled?: boolean;
  id?: string;
  name?: string;
  value?: string;
  label?: string;
  description?: string;
  error?: string;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

export default function Checkbox({
  checked = false,
  onChange,
  onBlur,
  onFocus,
  required = false,
  disabled = false,
  id,
  name,
  value,
  label,
  description,
  error,
  className = '',
  size = 'md'
}: CheckboxProps) {
  const baseClasses = 'text-trust-blue focus:ring-trust-blue border-border-light rounded transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed';

  const sizeClasses = {
    sm: 'h-3 w-3',
    md: 'h-4 w-4',
    lg: 'h-5 w-5'
  };

  const errorClass = error ? 'border-error-red focus:ring-error-red' : '';

  const checkboxClasses = `${baseClasses} ${sizeClasses[size]} ${errorClass} ${className}`;

  const labelSizeClasses = {
    sm: 'text-body-sm',
    md: 'text-supporting',
    lg: 'text-body-md'
  };

  return (
    <div className="flex items-start space-x-3">
      <div className="flex items-center">
        <input
          type="checkbox"
          id={id}
          name={name}
          value={value}
          checked={checked}
          onChange={onChange}
          onBlur={onBlur}
          onFocus={onFocus}
          required={required}
          disabled={disabled}
          className={checkboxClasses}
        />
      </div>

      {(label || description) && (
        <div className="flex-1">
          {label && (
            <label
              htmlFor={id}
              className={`block font-medium text-gray-700 cursor-pointer ${labelSizeClasses[size]}`}
            >
              {label}
              {required && <span className="text-error-red ml-1">*</span>}
            </label>
          )}

          {description && (
            <p className="text-caption text-text-secondary mt-1">
              {description}
            </p>
          )}

          {error && (
            <p className="text-error-red text-caption mt-1">
              {error}
            </p>
          )}
        </div>
      )}
    </div>
  );
}